import { render, staticRenderFns } from "./MemberDetail.vue?vue&type=template&id=8b4eec1a&scoped=true&"
import script from "./MemberDetail.vue?vue&type=script&lang=js&"
export * from "./MemberDetail.vue?vue&type=script&lang=js&"
import style0 from "./MemberDetail.vue?vue&type=style&index=0&id=8b4eec1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4eec1a",
  null
  
)

export default component.exports